<template>
  <layout-main-inner>
    <el-button
      slot="action"
      type="primary"
      @click="addRow">新增服务机构</el-button>
    <layout-card-wrap hasHeaderSlot>
      <template slot="form">
        <el-input
          v-model="config.servOrgName"
          placeholder="请输入服务机构名称"
          clearable=""
          style="width: 240px;"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="机构名称"
          fixed="left"
          min-width="200"
          prop="servOrgName"> </el-table-column>
        <!-- <el-table-column
          label="首图"
          width="150">
          <template slot-scope="{ row }">
            <el-image
              style="width: 104px; height: 60px"
              :src="row.image"
              :preview-src-list="[row.image]"></el-image>
          </template>
        </el-table-column> -->
        <el-table-column
          label="服务数量"
          min-width="100"
          prop="servCount"> </el-table-column>
        <el-table-column
          label="地址"
          min-width="200"
          prop="address"> </el-table-column>
        <el-table-column
          label="联系方式"
          width="120"
          prop="contactPhone"> </el-table-column>
        <el-table-column
          label="排序值"
          width="80"
          prop="sortNumber"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="110">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateRow(row)">编辑</el-button>
            <el-dropdown>
              <el-button
                type="text"
                style="margin-left: 10px;">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetail(row)">查看详情</el-dropdown-item>
                <el-dropdown-item @click.native="showUser(row)">机构员工管理</el-dropdown-item>
                <el-dropdown-item @click.native="deleteRow(row)">删除机构</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>

    <edit-org-modal
      ref="service"
      @fetch="fetchList" />
    <org-staff-modal ref="staff" />
    <detail-drawer ref="detail" />
  </layout-main-inner>
</template>
<script>
import DetailDrawer from './org/detail-drawer.vue'
import OrgStaffModal from './org/org-staff-modal.vue'
import EditOrgModal from './org/edit-org-modal.vue'
import OrgService from '@/service/org-service'
export default {
  name: 'ServiceOrg',
  components: { EditOrgModal, DetailDrawer, OrgStaffModal },
  data() {
    return { loading: true, list: [], total: 0, config: { pageNum: 1, pageSize: 10, servOrgName: '' }}
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    showDetail(row) {
      this.$refs.detail.fetch({ id: row.id })
    },
    showUser(row) {
      this.$refs.staff.fetch({ orgId: row.id })
    },
    updateRow(row) {
      this.$refs.service.init({ ...row })
    },
    addRow() {
      this.$refs.service.init()
    },
    deleteRow(row) {
      this.$confirm('您确定删除该服务机构?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          OrgService.deleteservorg({ id: row.id })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      OrgService.getservorgs({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0, 13].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
